// extracted by mini-css-extract-plugin
export default {"value":"lGfRl","price":"srDW6","revertOld":"D9VZe","revert":"_4U3kG","labeled":"MOeaj","label":"AtFCC"};